var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 18,
    viewBox: "0 0 65 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3056_14366)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -0.105835H3.79994H5.75912H5.81294C7.65371 -0.105835 8.49335 1.20711 8.95623 2.71064L11.4106 10.673H11.895L14.3494 2.71064C14.8122 1.21769 15.6411 -0.0846585 17.4604 -0.105835H17.5034H19.5056H23.2195V17.9683H17.4604V7.2424H17.0621L13.6604 17.9683H9.64518L6.25429 7.2424H5.75912V17.9683H0V-0.105835ZM52.4349 12.24H58.6676C61.3696 12.24 63.684 10.5353 64.5667 8.17416H52.4349H46.6758V12.24V17.9789H52.4349V12.24ZM25.6415 -0.105835H31.4006V10.62H32.1542C33.3275 7.98358 34.4794 5.34711 35.6312 2.71064C36.417 0.910635 37.1921 0.127106 39.1405 -0.105835H41.1427H44.0815V17.9683H38.3224V7.2424H37.7518C36.5785 9.87887 35.4266 12.5153 34.2748 15.1518C33.5213 16.8777 32.6924 17.7989 30.7655 17.9683H28.7633H25.6415V-0.105835Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6992 0H58.5883C61.902 0 64.5883 2.68629 64.5883 6V7.10688H52.6992C49.3855 7.10688 46.6992 4.42058 46.6992 1.10687V0Z",
    fill: "#A5A5A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3056_14366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.5882,
    height: 18,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMir);
export default __webpack_public_path__ + "static/media/mir.7020e12b.svg";
export { ForwardRef as ReactComponent };